<template>
  <div class="cabinet-rows">
    <div v-for="row in rows" :key="row.label" class="cabinet-rows__row">
      <span>{{ row.label }}</span>
      <strong>{{ row.value }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CabinetRows',
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-rows__row
  display: flex
  align-items: flex-start
  justify-content: space-between
  gap: 16px
  padding: 12px 0
  border-bottom: 1px solid #ededed
  color: #858585
  font-size: 14px
  line-height: 1.35

  strong
    color: #3b3b3b
    font-weight: 500
    text-align: right
    overflow-wrap: anywhere
</style>
